import { useState } from 'react';
import './Core.css';
import Select from '../components/Select';
import Check from '../components/Check';
import Table from '../components/Table';
import getEntities from '../services/entities';
import { contextsColors, contextsKeys, contextsNames } from '../config';
import getReport from '../services/reports';

const exigencia = ['BAJO', 'MEDIO', 'ALTO'];
const exigenciaColor = ['#E7D295', '#9C2348', '#621333'];

function Core() {
  let [state, setState] = useState('0')
  let [town, setTown] = useState({ id: 0, idexigencia: 0 })
  let [visibleTowns, setVisibleTowns] = useState(false)
  let [visibleInfo, setVisibleInfo] = useState(false)
  let [contexts, setContexts] = useState({ 'F': false, 'M': false, 'C': false, 'I': false })

  const handleChangeState = evt => {

    console.log('State: ', evt.target.value);

    if(evt.target.value !== '0') setVisibleTowns(true);
    else setVisibleTowns(false); 
    
    setVisibleInfo(false);

    getEntities('/catalogos/estados', { }).then(states => {
      setState(states[parseInt(evt.target.value) - 1]);
    })
  }

  const handleChangeTown = evt => {
    if(evt.target.value !== '0') {
      setVisibleInfo(true);

      getEntities('/catalogos/municipio', { townId: parseInt(evt.target.value) }, true).then(townData => {
        setTown(townData);
      })
    }
    else setVisibleInfo(false);
  }

  const handleChangeContext = evt => {
    const ctxts = {};
    const contextsKeys = Object.keys(contexts);
    for(const contextsKey of contextsKeys) {
      if(contextsKey === evt.target.value)
        ctxts[contextsKey] = !contexts[contextsKey];
      else
        ctxts[contextsKey] = contexts[contextsKey];
    }
    setContexts(ctxts);
  }

  const handleReportGeneration = evt => {
    getReport({ requirementId: town.idexigencia, contexts }, state.nombre + ' - ' + town.nombre)
      .then(report => { })
  }

  let visibleInfoClass = '';
  if(!visibleInfo) visibleInfoClass = 'hide';

  return (
    <div className="core-container vertical-content">
      <div className="horizontal-content">
        <div className="vertical-content selection-container">
          <div className='title-container'>
            <h2>SELECCIÓN DE ESTADO Y MUNICIPIO</h2>
          </div>
          <div style={{ width: '100%' }}>
            <hr className="red" style={{ margin: '10px 0 30px' }}></hr>
          </div>
            
          <div className="horizontal-content cards-container" style={{ justifyContent: 'start'}}>
            <Select
                path="/catalogos/estados"
                name="Estado"
                onChangeFcn={ handleChangeState }
                visible={ true }
                label="Entidad de análisis: "
                data={{ }}
            />
            <Select
                path="/catalogos/municipios"
                name="Municipio"
                onChangeFcn={ handleChangeTown }
                visible={ visibleTowns }
                label="Municipio: "
                data={{ stateId: state.id }}
            />
          </div>
          <div className={ visibleInfoClass } style={ {marginTop: '30px', alignItems: 'flex-start', textAlign: 'left' } }>
            <span className='text-small'><b>
              Marca las características de contexto correspondientes al municipio:
            </b></span>
          </div>
          <div className="horizontal-content horizontal-adjustable-content">
            {
              contextsKeys.map((key, index) => {
                return <Check
                  key={ `check-${ key }` }
                  onChangeFcn={ handleChangeContext }
                  visible={ visibleInfo }
                  value={ key }
                  name={ contextsNames[index] }
                />
              })
            }
          </div>
          <div>
            <div className='text-small selection-notes'>
              *Para identificar si un municipio es metropolitano o no, deberá confirmar si forma parte de una Zona
              Metropolitana, de conformidad con la delimitación establecida en la publicación Metrópolis de México
              2020 (CONAPO, INEGI y SEDATU, 2023) o la que la sustituya.
            </div>
            
            <div className='text-small selection-notes'>
            *A fin de verificar si en el municipio aplican los contenidos correspondientes al rasgo de etnicidad
            (indígena o afrodescendiente), se deberán consultar los tabulados del Censo de Población y Vivienda
            2020 por municipio en la Entidad Federativa correspondiente.
            </div>
          </div>
        </div>
        <div className='vertical-content selection-image'>
          <img className="full-width" src="imgs/core/Contexto.png" alt="Contexto"/>
        </div>
      </div>
      <div className={ visibleInfoClass + ' vertical-content statistics-container' }>
        <div className='full-width horizontal-content title-container'>
            <h2>NIVEL DE REQUERIMIENTO Y CONTENIDOS</h2>
        </div>
        <div style={{ width: '100%' }}>
          <hr className="red" style={{ margin: '5px 0 5px' }}></hr>
        </div>
        <div className='horizontal-content horizontal-adjustable-content'>
          <div className='horizontal-content horizontal-adjustable-content statistics-requirement-container'>
            <div className='statistics-requirement-info' style={{ textAlign: 'justify' }}>
              El nivel de requerimiento de <b>{ town.nombre }, { state.nombre }</b> es:
            </div>
            <div className='statistics-requirement-signal'>
              <div className='statistics-requirement-signal-outter' style={ { borderColor: exigenciaColor[town.idexigencia - 1]} }>
                <div className='statistics-requirement-signal-inner'
                  style={ { backgroundColor: exigenciaColor[town.idexigencia - 1], color: town.idexigencia < 2 ? '#0D3847': 'white'} }>
                  { exigencia[town.idexigencia - 1] }
                </div>
              </div>
            </div>
          </div>
          <div className='vertical-content statistics-contexts-container'>
            <div className='text-small statistics-contexts-section'>
              <span>Los contenidos que le corresponde desarrollar según lo seleccionado son:</span>
            </div>
            <div className='statistics-contexts-section statistics-contexts-titles'>
              GENÉRICOS BÁSICOS { town.idexigencia > 1 ? ' Y AMPLIADOS' : '' }
            </div>
            <div className='statistics-contexts-section statistics-contexts-titles'>
              + DE CONTEXTO BÁSICOS { town.idexigencia > 2 ? ' Y AMPLIADOS' : '' }
            </div>
            {
              contextsKeys.map((key, index) => {
                if(contexts[key]){
                  return <div className='horizontal-content statistics-contexts-section statistics-contexts-tags' key={`div-tag-${key}`}> 
                    <div className='flag-context-div' style={{ backgroundColor: `#${ contextsColors[index] }` }}>
                      <span></span>
                    </div>
                    <span style={{ paddingLeft: '7px' }} className='text-small'>Rasgo { contextsNames[index] }</span>
                  </div>
                }
                return <div key={`div-tag-${key}`}></div>
              })
            }
          </div>
          <div></div>
        </div>
      </div>
      <div className={ visibleInfoClass + ' vertical-content table-container' }>
        <div className='full-width horizontal-content title-container'>
          <h2>TABLA DE CONTENIDOS A DESARROLLAR</h2>
        </div>
        <div style={{ width: '100%' }}>
          <hr className="red" style={{ margin: '10px 0 10px' }}></hr>
        </div>
      </div>
      <div className={ visibleInfoClass + ' vertical-content' }>
        <div className='full-width horizontal-content table-button-container'>
          <button
            onClick={ handleReportGeneration }
            className='btn btn-primary'
          >
            Descargar
          </button>
        </div>
        
        <Table 
          visible={ visibleInfo }
          data={ { requirementId: town.idexigencia, contexts } }
        />
      </div>
    </div>
  );
}

export default Core;
